import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feria-negocios',
  templateUrl: './feria-negocios.component.html',
  styleUrls: ['./feria-negocios.component.scss']
})
export class FeriaNegociosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
